import { ajax } from '../index'

/**
 * 首页相关接口
 */
export default {
  // 获取CSOTD数据
  getCsotd() {
    return ajax.get('api', `/api/v1/product/crazy-deal/otd`, {})
  },

  // 获取首页推荐商品数据
  getHomeRecommended(dataObj: any) {
    return ajax.get('api', `/api/v1/recommended/someone`, dataObj)
  },

  // 获取支付成功页推荐商品数据
  getTopSellerRecommended(dataObj: any) {
    return ajax.get('api', `/api/v1/product/list/top-seller`, dataObj)
  },

  // 获取用户数据
  getCurrentCustomerInfo() {
    return ajax.get('api', `/api/getCurrentCustomerInfo`, {})
  }
}